import React from 'react';
import { motion } from 'framer-motion';
import { StarsBackground } from './ui/StarsBackground';
import { TagIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/meta-pixel';
export function OfferSection() {
  return <section id="oferta" className="py-24 px-4 bg-navy-950 relative overflow-hidden" data-id="element-157">
      <StarsBackground data-id="element-158" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-navy-900/80 backdrop-blur-md p-8 md:p-14 rounded-3xl border border-amber-500/30 shadow-2xl" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-cream-50 mb-6" data-id="element-161">
            Recupera tu salud mental y el descanso de tu familia hoy mismo.
          </h2>

          <p className="text-lg text-cream-100/80 font-body mb-10 max-w-2xl mx-auto" data-id="element-162">
            El precio de dormir una noche completa es invaluable, pero puedes
            obtener este sistema completo por una fracción de lo que cuesta una
            consultora de sueño privada.
          </p>

          <div className="mb-10" data-id="element-163">
            <span className="text-cream-200 font-body uppercase tracking-widest text-sm mb-4 block" data-id="element-164">
              Inversión
            </span>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="inline-flex items-center gap-2 bg-red-500/20 border border-red-400/30 text-red-300 font-body text-sm font-semibold px-4 py-1.5 rounded-full mb-4" data-id="element-165">
              <TagIcon className="w-4 h-4" data-id="element-166" />
              Descuento especial este mes
            </motion.div>

            <div className="mb-2" data-id="element-167">
              <span className="text-2xl md:text-3xl font-display text-cream-100/40 line-through" data-id="element-168">
                $27.00 USD
              </span>
            </div>

            <div id="oferta-precio" className="text-6xl md:text-7xl font-display font-bold text-amber-400 drop-shadow-lg" data-id="element-169">
              $6.39{' '}
              <span className="text-2xl md:text-3xl text-amber-400/70" data-id="element-170">
                USD
              </span>
            </div>

            <p className="text-sm text-green-400/80 font-body mt-2 font-medium" data-id="element-171">
              Ahorras $20.61 — 76% de descuento
            </p>
          </div>

          <a href="https://esenciaequilibrio.com/cart/47393742192876:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="w-full md:w-auto inline-block text-center bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-navy-950 font-bold font-body text-lg md:text-xl py-5 px-8 md:px-12 rounded-full shadow-[0_0_20px_rgba(251,191,36,0.4)] hover:shadow-[0_0_30px_rgba(251,191,36,0.6)] transition-all duration-300 animate-pulse-glow transform hover:-translate-y-1" data-id="element-172">
            SÍ, QUIERO QUE MI BEBÉ DUERMA
          </a>

          <p className="mt-6 text-sm text-cream-100/60 font-body italic" data-id="element-173">
            *Acceso instantáneo después del pago. Formato PDF apto para celular
            y tablet.
          </p>
        </motion.div>
      </div>
    </section>;
}